export default [
   {
      path: '/mppd/permohonan',
      name: 'mppd-permohonan',
      component: () => import('@/views/mppd/Permohonan.vue'),
      meta: {
         pageTitle: 'MPPD',
         breadcrumb: [
            {
               text: 'MPPD',
               active: false,
            },
            {
               text: 'Permohonan',
               active: true,
            },
         ],
      },
   },
   {
      path: '/mppd/permohonanv2',
      name: 'mppd-permohonanv2',
      component: () => import('@/views/mppd/PermohonanV2.vue'),
      meta: {
         pageTitle: 'MPPD V2.0',
         breadcrumb: [
            {
               text: 'MPPD V2.0',
               active: false,
            },
            {
               text: 'Permohonan',
               active: true,
            },
         ],
      },
   },
   {
      path: '/mppd/scrap',
      name: 'mppd-scrap-data',
      component: () => import('@/views/mppd/Scrap.vue'),
      meta: {
         pageTitle: 'Permohonan Scrap',
         breadcrumb: [
            {
               text: 'MPPD',
               active: false,
            },
            {
               text: 'Scrap',
               active: true,
            },
         ],
      },
   },
   {
      path: '/mppd/scrap-document',
      name: 'mppd-scrap-document',
      component: () => import('@/views/mppd/ScrapDocument.vue'),
      meta: {
         pageTitle: 'Permohonan Scrap Document',
         breadcrumb: [
            {
               text: 'MPPD',
               active: false,
            },
            {
               text: 'Scrap',
               active: true,
            },
         ],
      },
   },
]
